import { Check, Trophy, Star, Crown, Zap, Sparkles, Target, Gift } from 'lucide-react'
import { SectionHeader } from './LandingJourneySection'

const steps = [
  {
    n: '01',
    title: 'Escolha uma Jornada',
    desc: 'Explore trilhas alinhadas aos seus interesses e objetivos.',
    color: 'bg-brand-coral text-brand-dark'
  },
  {
    n: '02',
    title: 'Complete Desafios',
    desc: 'Ganhe experiência e desbloqueie novos conteúdos a cada etapa.',
    color: 'bg-brand-green text-brand-dark'
  },
  {
    n: '03',
    title: 'Evolua de Nível',
    desc: 'Colecione medalhas, títulos e conquistas ao longo da jornada.',
    color: 'bg-brand-pink text-white'
  },
  {
    n: '04',
    title: 'Torne-se Protagonista',
    desc: 'Transforme seu aprendizado em impacto real.',
    color: 'bg-brand-cyan text-brand-dark'
  }
]

export function LandingHowItWorks() {
  return (
    <section id="como-funciona" className="bg-brand-purple py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeader
          dark
          eyebrow="Como Funciona"
          title={
            <>
              Quatro passos para{' '}
              <span className="font-hl text-brand-yellow">começar</span>.
            </>
          }
          subtitle="Tão simples quanto começar um jogo. Tão poderoso quanto mudar o seu futuro."
        />

        <div className="mt-16 grid gap-12 lg:grid-cols-2 lg:items-center">
          <ol className="relative space-y-6 lg:space-y-8">
            <div className="absolute left-8 top-4 bottom-4 w-1 rounded-full bg-gradient-to-b from-brand-cyan via-brand-yellow to-brand-pink" />
            {steps.map((s) => (
              <li key={s.n} className="relative flex items-start gap-5">
                <div
                  className={`relative z-10 grid size-16 shrink-0 place-items-center rounded-2xl ${s.color} font-hl text-xl shadow-[0_5px_0_var(--color-brand-dark)]`}
                >
                  {s.n}
                </div>
                <div className="rounded-2xl border-2 border-gray-100 bg-white p-5 shadow-sm">
                  <h3 className="font-hl text-xl text-gray-900">{s.title}</h3>
                  <p className="mt-1 text-gray-500">{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <div className="relative mx-auto w-full max-w-md">
            <MockGameScreen />
          </div>
        </div>
      </div>
    </section>
  )
}

function MockGameScreen() {
  const medalIcons = [Star, Trophy, Crown, Zap, Sparkles, Target, Gift, Star]

  return (
    <div className="relative">
      {/* Card de fundo */}
      <div className="absolute -left-6 top-8 w-full -rotate-6 rounded-[2rem] bg-brand-yellow p-5 shadow-xl ring-1 ring-black/10">
        <div className="flex items-center gap-3">
          <Trophy className="size-6 text-brand-dark" />
          <div className="font-hl text-lg text-brand-dark">Conquistas</div>
        </div>
        <div className="mt-4 grid grid-cols-4 gap-2">
          {medalIcons.map((Icon, idx) => (
            <div
              key={idx}
              className={`grid aspect-square place-items-center rounded-xl ${
                idx < 5 ? 'bg-brand-dark text-brand-cyan' : 'bg-brand-dark/20 text-brand-dark/40'
              }`}
            >
              <Icon className="size-5" />
            </div>
          ))}
        </div>
      </div>

      {/* Card frontal */}
      <div className="relative rotate-[3deg] rounded-[2rem] bg-gradient-to-br from-brand-blue to-brand-purple p-6 text-white shadow-2xl ring-1 ring-white/20">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-widest text-white/70">Missão atual</div>
            <div className="mt-1 font-hl text-2xl">Pitch do meu negócio</div>
          </div>
          <div className="grid size-12 place-items-center rounded-xl bg-brand-yellow text-brand-dark font-hl text-lg">
            03
          </div>
        </div>
        <div className="mt-5 space-y-2 text-sm">
          {[
            { t: 'Definir proposta de valor', done: true },
            { t: 'Mapear público-alvo', done: true },
            { t: 'Gravar pitch de 60s', done: false }
          ].map((x) => (
            <div key={x.t} className="flex items-center gap-3 rounded-xl bg-white/10 px-3 py-2">
              <div
                className={`grid size-6 place-items-center rounded-md ${
                  x.done ? 'bg-brand-green text-brand-dark' : 'bg-white/10'
                }`}
              >
                {x.done && <Check className="size-4" strokeWidth={3} />}
              </div>
              <span className={x.done ? 'line-through opacity-70' : ''}>{x.t}</span>
            </div>
          ))}
        </div>
        <div className="mt-5 flex items-center justify-between rounded-2xl bg-brand-dark/40 px-4 py-3">
          <div className="text-sm">
            Recompensa{' '}
            <span className="font-hl text-brand-yellow">+300 XP</span>
          </div>
          <div className="rounded-full bg-brand-cyan px-4 py-1.5 text-sm font-bold text-brand-dark">
            Continuar
          </div>
        </div>
      </div>
    </div>
  )
}
